
export const ButtonTheme = {
	// style object for base or default style
	baseStyle: {},
	// styles for different sizes ("sm", "md", "lg")
	sizes: {},
	// styles for different visual variants ("outline", "solid")
	variants: {
		primary: {
			bg: 'darkCoral',
			color: 'white',
			p: '3',
			px: '4',
			borderWidth: 1,
			borderRadius: 5,
			borderColor: 'darkCoral',
			fontSize: 'sm',
			_disabled: {
				bg: 'lightGrey',
				color: 'brand.black',
				borderColor: 'brand.black',
			},

			_loading: {
				bg: 'darkCoral',
				_hover: {
					bg: 'darkCoral',
				},
			},

			_hover: {
				bg: 'white',
				color: 'darkCoral',
				borderColor: 'darkCoral',
				_disabled: {
					bg: 'lightGrey',
					color: 'brand.black',
					borderColor: 'brand.black',
				},
			},
		},
		secondary: {
			bg: 'white',
			color: 'darkCoral',
			borderWidth: '1px',
			borderColor: 'darkCoral',
			p: '3',
			px: '4',
			borderRadius: 5,
			fontSize: 'sm',
			_disabled: {
				bg: 'lightGrey',
			},

			_hover: {
				bg: 'darkCoral',
				color: 'white',
				borderColor: 'darkCoral',
				_disabled: {
					bg: 'lightGrey',
					color: 'white',
					borderColor: 'lightGrey',
				},
			},
		},
		dark: {
			bg: 'brand.black',
			color: 'white',
			fontSize: 'sm',
			p: '3',
			px: '4',
			borderWidth: 1,
			borderRadius: 3,
			_hover: {
				bg: 'white',
				color: 'brand.black',
				borderColor: 'brand.black',
				_disabled: {
					bg: 'lightGrey',
					color: 'white',
					borderColor: 'lightGrey',
				},
			},
			_disabled: {
				bg: 'lightGrey',
			},
		},

		grey: {
			bg: 'loopGrey.900',
			color: 'loopGrey.500',
			fontSize: 'sm',
			p: '3',
			px: '4',
			borderWidth: 1,
			borderRadius: 3,

			_hover: {
				bg: 'white',
				color: 'loopGrey.500',
			},

			_disabled: {
				bg: 'white',
			},
		},

		greyBorder: {
			bg: 'white',
			color: 'blackTextColor.200',
			fontSize: 'xs',
			fontWeight: '300',
			p: '2',
			px: '3',
			borderWidth: 1,
			borderRadius: '20px',
			borderColor: 'rgba(88, 96, 104, 0.3)',

			_hover: {
				bg: 'loopGrey.500',
				borderColor: 'loopGrey.500',
				color: 'white',
			},

			_disabled: {
				bg: 'white',
			},
		},
	},
	// default values for `size` and `variant`
	defaultProps: {
		size: '',
		variant: '',
	},
};